import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Servers from './pages/Servers';
import Downloads from './pages/Downloads';
import Register from './pages/Register';
import NotFound from './pages/NotFound';
import ActivateAccount from './pages/ActivateAccount';
import NewsList from './pages/NewsList';
import NewsDetail from './pages/NewsDetail';
import GuidesList from './pages/GuidesList';
import GuideDetail from './pages/GuideDetail';
import { initImageProtection } from './utils/imageProtection';
import { initPerformanceOptimizations } from './utils/performanceUtils';
import { optimizeScrollPerformance } from './utils/scrollUtils';
import { isMobileDevice } from './utils/deviceUtils';

function App() {
  useEffect(() => {
    initImageProtection();
    initPerformanceOptimizations();

    // Apply scroll performance optimizations
    const cleanupScrollOptimizer = optimizeScrollPerformance();
    
    // Add mobile class to body if on mobile device
    if (isMobileDevice()) {
      document.body.classList.add('mobile-device');
    }
    
    return () => {
      cleanupScrollOptimizer();
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="servers" element={<Servers />} />
        <Route path="download" element={<Downloads />} />
        <Route path="register" element={<Register />} />
        <Route path="activate/:token" element={<ActivateAccount />} />
        
        {/* Thêm các đường dẫn cho tin tức */}
        <Route path="news" element={<NewsList />} />
        <Route path="news/:slug" element={<NewsDetail />} />
        
        {/* Thêm các đường dẫn cho hướng dẫn */}
        <Route path="guides" element={<GuidesList />} />
        <Route path="guides/:slug" element={<GuideDetail />} />
        
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;

